import { render, staticRenderFns } from "./question_detail.vue?vue&type=template&id=618edc04&scoped=true&"
import script from "./question_detail.vue?vue&type=script&lang=js&"
export * from "./question_detail.vue?vue&type=script&lang=js&"
import style0 from "./question_detail.vue?vue&type=style&index=0&id=618edc04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618edc04",
  null
  
)

export default component.exports